const host = "https://lcf3slkxt0.execute-api.eu-north-1.amazonaws.com/dev/";
const externalHost = "https://demo.svenskafribrevsbolaget.se";
export default {
  env: "dev",
  domain: host,
  BASE_URL: host,
  baseName: "/",
  EXTERNAL_URL: externalHost,
  language: "sv",
  markerDestinationId: "6568a81f51c10145c25d62c1",
  api: {
    maxAge: 15 * 60 * 1000, // 15 minutes
  },
};
